VjsAdmin.LicenseLessons = (function () {
    const init = function () {
        // go through each already selected package
        // and add the inferred and inferred-{package_id} classes
        $('#license-packages input:checked').each(function () {
            const packageId = $(this).data('package-id');
            const lessonIds = $(this).data('lesson-ids').split(',');

            $.each(lessonIds, (index, lessonId) => {
                const $lessonCheckbox = $(`#license-lesson input:checkbox[data-lesson-id=${lessonId}]`);
                $lessonCheckbox.addClass('inferred');
                $lessonCheckbox.addClass(`inferred-${packageId}`);
            });
        });

        // when a package is checked or unchecked...
        //  check or uncheck the related lessons
        $('#license-packages').on('change', 'input:radio', function () {
            const packageId = $(this).data('package-id');
            const lessonIds = $(this).data('lesson-ids').split(',');

            $('#license-lessons input:checkbox')
                .prop('checked', false)
                .removeClass('inferred-1')
                .removeClass('inferred-2')
                .removeClass('inferred-3');
            $.each(lessonIds, (index, lessonId) => {
                const lessonCheckbox = $(`#license-lessons input:checkbox[data-lesson-id=${lessonId}]`);
                lessonCheckbox.addClass('inferred').addClass(`inferred-${packageId}`).prop('checked', true);
            });
        });
    };

    return {
        init,
    };
}());
